import { Exclude, Expose } from "class-transformer";
import { IsBoolean, IsDefined } from "class-validator";

import { TransformToDate } from "../transformers/transformToDate";

@Exclude()
export class DateRange {
    @IsBoolean()
    @IsDefined()
    @Expose()
    public isYearless: boolean;

    @IsDefined()
    @Expose()
    @TransformToDate
    public startAt: Date;

    @IsDefined()
    @Expose()
    @TransformToDate
    public endAt: Date;
}
